import { render, staticRenderFns } from "./VueDialog.vue?vue&type=template&id=2296f03e&scoped=true&"
import script from "./VueDialog.vue?vue&type=script&lang=js&"
export * from "./VueDialog.vue?vue&type=script&lang=js&"
import style0 from "./VueDialog.vue?vue&type=style&index=0&id=2296f03e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296f03e",
  null
  
)

export default component.exports